import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { PortalInputField } from 'components/FormControls';
const classNames = require('classnames');

require('./style.css');

interface IProps {
	keyword?: string;
	placeholder?: string;
	onSearchEnterPress?: (event: any) => void;
	onSearchValueChange?: (e: any) => void;
	t?: (key: string) => string;
	onClearSearchInput?: () => void;
	customRef?: React.RefObject<HTMLInputElement>;
	customIconSizeWidth?: number;
	customIconSizeHeight?: number;
	doesNotNeedUrlChange?: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SearchInput extends React.Component<IProps, any> {
	public searchInput: HTMLInputElement = null;
	private hasText: boolean = false;

	constructor(props) {
		super(props);

		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.handleClearSearchInput = this.handleClearSearchInput.bind(this);
	}

	private handleSearchEnterPress(event: any) {
		if (this.props.onSearchEnterPress) {
			this.props.onSearchEnterPress(event);
		}
	}

	private handleSearchValueChange(e: any) {
		const value: string = e.target.value;
		if (value && value.length > 0) {
			this.hasText = true;
		} else {
			this.hasText = false;
		}

		if (this.props.onSearchValueChange) {
			this.props.onSearchValueChange(e);
		}
	}

	private handleClearSearchInput() {
		if (this.props.onClearSearchInput) {
			this.props.onClearSearchInput();
		}
		this.hasText = false;
	}

	public render() {
		const { placeholder, t, customIconSizeHeight, customIconSizeWidth } = this.props;

		let placeholderString = t('BSPortal_Common_Search');
		if (placeholder) {
			placeholderString = placeholder;
		}

		return (
			<div className={classNames('searchInput', { ['hasText']: this.hasText === true })}>
				<PortalInputField
					input={{
						name: 'search',
						type: 'text',
						value: this.props.keyword,
						onChange: this.handleSearchValueChange,
						onKeyPress: this.handleSearchEnterPress,
						autoFocus: true,
						ref: (searchInput) => {
							this.searchInput = searchInput;
						},
					}}
					label={placeholderString}
					className="rounded"
					iconName={'close'}
					iconClassName="pointer"
					iconAction={this.handleClearSearchInput}
					customRef={this.props.customRef}
					customIconSizeHeight={customIconSizeHeight}
					customIconSizeWidth={customIconSizeWidth}
					doesNotNeedUrlChange={this.props.doesNotNeedUrlChange}
				/>
			</div>
		);
	}
}

export { SearchInput };
